import { useRef } from 'react';

function SidebarCollapse({ title, children, className = '', isOpen, onToggle }) {
    const contentRef = useRef(null);

    return (
        <div
            className={`${isOpen ? 'border-l-yellow' : 'border-l-[#eeeeee]'} medium:p-2 medium:text-base small:p-2 mx-2 border border-l-[4px] border-solid border-transparent border-b-[#eeeeee] p-4 text-xl ${className}`}
        >
            <div
                onClick={onToggle}
                className={`text-dark relative flex w-full cursor-pointer items-center justify-between text-left focus:outline-none`}
            >
                <div className='font-bold'>{title}</div>
            </div>

            <div
                className={`overflow-hidden transition-all duration-300`}
                style={{
                    maxHeight: isOpen ? `${contentRef.current.scrollHeight + 100}px` : '0px',
                }}
                ref={contentRef}
            >
                <div className='medium:text-sm mt-5 text-base'>{children}</div>
            </div>
        </div>
    );
}

export default SidebarCollapse;
